import React, { Component } from "react";
import * as d3 from "d3";
import "../style.css";
import moment from "moment";
import { downloadChargeHistory } from "../JSONCSV";
import Table from "../Table/index";
import _ from "lodash";
import EmptyState from "../../../../../../../assets/svg/evNoData.svg";

class ChargeHistory extends Component {
  constructor(props) {
    super(props);
    this.state = {
      viewIdx: 0,
    };
  }

  // processData(withMoment){
  //     var parseTime = d3.timeParse("%H");
  //     let bars=[];
  //     let data= Object.entries(this.props.data);
  //     for(let idx in data){
  //         bars.push({
  //             hour:withMoment?moment(parseTime(data[idx][0])).format("h:mm A"):data[idx][0],
  //             count:data[idx][1]["count"],
  //             vehicles:data[idx][1]["vehiclelist"]
  //         })
  //     }
  //     return bars
  //     }

  getSortedData() {
    let sortedData = _.orderBy(this.props.data, ["time"], ["asc"]);
    sortedData.sort(function (a, b) {
      return (a["time"] === null) - (b["time"] === null);
    });
    return sortedData;
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.isExpanded == "ct005" && this.state.viewIdx === 0) {
      this.renderLineChart(500, 220);
    }
  }

  renderLineChart(refWidth = 400, refHeight = 160) {
    const data = this.getSortedData();
    var margin = { top: 10, right: 10, bottom: 20, left: 40 },
      width = refWidth - margin.left - margin.right,
      height = refHeight - margin.top - margin.bottom;

    // parse the date / time
    var parseTime = d3.timeParse("%H");

    // set the ranges
    var x = d3.scaleTime().range([0, width]);
    var y = d3.scaleLinear().range([height, 0]);

    // define the line
    var valueline = d3
      .line()
      .x(function (d) {
        return x(d.hours);
      })
      .y(function (d) {
        return y(d.count);
      });

    // append the svg obgect to the body of the page
    // appends a 'group' element to 'svg'
    // moves the 'group' element to the top left margin
    var svg = d3.select(this.refs.chargeHistoryGraph);
    svg.selectAll("svg").remove();

    var svg = d3
      .select(this.refs.chargeHistoryGraph)
      .append("svg")
      .attr("width", width + margin.left + margin.right)
      .attr("height", height + margin.top + margin.bottom)
      .append("g")
      .attr("transform", "translate(" + margin.left + "," + margin.top + ")");

    // format the data
    //   data.forEach(function(d) {
    //       d.hours = parseTime(moment(d.time).format("h:"));
    //       d.count = +d.count;
    //   });

    // Scale the range of the data
    x.domain(
      d3.extent(data, function (d) {
        return d.hours;
      })
    );
    y.domain([
      0,
      d3.max(data, function (d) {
        return d.count;
      }),
    ]);

    // Add the valueline path.
    svg
      .append("path")
      .data([data])
      .attr("class", "line")
      .attr("stroke", "#ffc478")
      .attr("d", valueline);

    // Add the X Axis
    //   svg.append("g")
    //       .attr("transform", "translate(0," + height + ")")
    //       .call(d3.axisBottom(x));

    // Add the Y Axis
    //   svg.append("g")
    //       .call(d3.axisLeft(y))

    svg
      .append("g")
      .attr("class", "x axis")
      .attr("transform", "translate(0," + height + ")")
      .call(
        d3.axisBottom(x).ticks(data.length).tickFormat(d3.timeFormat("%H:%M"))
      ); // Create an axis component with d3.axisBottom

    // 4. Call the y axis in a group tag
    svg
      .append("g")
      .attr("class", "y axis")
      .call(
        d3
          .axisLeft(y)
          .ticks(
            d3.max(data, function (d) {
              return d.count;
            }) > 10
              ? 10
              : d3.max(data, function (d) {
                  return d.count;
                })
          )
          .tickFormat((x) => `${x.toFixed(0)}`)
      );

    var div = d3
      .select(this.refs.chargeHistoryGraph)
      .append("div")
      .attr("class", "tooltip")
      .style("opacity", 0);

    // Y axis label:
    svg
      .append("text")
      .attr("text-anchor", "middle")
      .attr("transform", "rotate(-90)")
      .attr("y", -margin.left + 10)
      .attr("x", -60)
      .text("Charging Events")
      .style("font-size", "9");

    // create a tooltip
    var Tooltip = d3
      .select(this.refs.chargeHistoryGraph)
      .append("div")
      .style("opacity", 0)
      .attr("class", "tooltip")
      .style("background-color", "white")
      .style("border", "solid")
      .style("border-width", "2px")
      .style("border-radius", "5px")
      .style("padding", "5px");

    // Three function that change the tooltip when user hover / move / leave a cell
    var mouseover = function (d) {
      Tooltip.style("opacity", 1);
    };
    var mousemove = function (d) {
      Tooltip.html(
        '<div ><div ><i class="fa fa-clock" style="color:#ffc478"></i> <span style="margin-left:5px">' +
          moment(d.hours).format("h:mm A") +
          '</span></div><div style="margin-top:5px"><i class="fa fa-bolt" style="color:#5bcc5b;margin-right:8px"></i> Charging: ' +
          '<span style="color:#39b539;font-size:14px;font-weight:bolder">' +
          d.count +
          "</span></div>"
      )
        .style("left", d3.pointer(event)[0] + 70 + "px")
        .style("top", d3.pointer(event)[1] + "px");
      d3.select(this).attr("r", 6);
    };
    var mouseleave = function (d) {
      Tooltip.style("opacity", 0);
      d3.select(this).attr("r", 4);
    };

    svg
      .selectAll("myCircles")
      .data(data)
      .enter()
      .append("circle")
      .attr("fill", "#5bcc5b")
      .attr("stroke", "none")
      .attr("cx", function (d) {
        return x(d.hours);
      })
      .attr("cy", function (d) {
        return y(d.count);
      })
      .attr("r", 4)
      .attr("class", "line-dotcircle")
      // .on("mouseover", function(d) {
      //     svg.append("text")
      //       .text("Vehicle Charged: "+ d.count)
      //       .attr('class', 'tooltip').style("font-size","12px")
      //       .style("font-weight","500")
      //       .attr("x", x(d.hours))
      //       .attr("y", y(d.count))
      //       .attr('fill', 'red');
      //     })
      // .on("mouseout", function(d) {
      //     d3.selectAll('.tooltip').remove();
      // });

      .on("mouseover", mouseover)
      .on("mousemove", mousemove)
      .on("mouseleave", mouseleave);
    var ticks = d3.selectAll(".tick text");

    if (data.length > 8 && data.length <= 16) {
      ticks.each(function (_, i) {
        if (i % 2 !== 0) d3.select(this).remove();
      });
    }
    if (data.length > 16) {
      ticks.each(function (_, i) {
        if (i % 3 !== 0) d3.select(this).remove();
      });
    }

    // .on("touchend mouseleave", () => tooltip.call(callout, null));
  }

  componentDidMount() {
    if (!this.props.data) return;
    this.renderLineChart();
  }

  getHistoryCount() {
    let sum = _.sumBy(this.props.data, function (o) {
      return o.count;
    });
    return sum;
  }

  getCSVName() {
    let auth = window.auth;
    let date = moment().format("DD-MM-YYYY_Hmm");
    return auth.userinfo.username + "_Charging_Event_Log_" + date;
  }

  searchReport(key) {
    var filter, table, tr, td, i, txtValue;
    filter = key.toUpperCase();
    table = document.getElementById("chargeEventTable");
    tr = table.getElementsByTagName("tr");
    for (i = 0; i < tr.length; i++) {
      td = tr[i].getElementsByTagName("td")[0];
      if (td) {
        txtValue = td.textContent || td.innerText;
        if (txtValue.toUpperCase().indexOf(filter) > -1) {
          tr[i].style.display = "";
        } else {
          tr[i].style.display = "none";
        }
      }
    }
  }

  minimizeWidget(id) {
    this.props.setExpand(id);
    this.renderLineChart(400, 160);
  }

  render() {
    return (
      <div
        className={
          "widgetLayout " +
          (this.props.isExpanded === "ct005" ? "expandedWidget " : "")
        }
      >
        <div className="header">
          <div>Charging Event Log</div>

          <div
            className="rightIcons"
            style={{
              display: "flex",
              justifyContent: "space-between",
              width: 50,
              alignItems: "center",
            }}
          >
            <i
              onClick={() =>
                downloadChargeHistory(this.props.data, this.getCSVName())
              }
              className="fa fa-download"
            ></i>
            {this.props.isExpanded == "ct005" ? (
              <i
                onClick={() => this.minimizeWidget("ct005")}
                className="fa fa-window-minimize"
              ></i>
            ) : (
              <i
                onClick={() => this.props.setExpand("ct005")}
                className="fa fa-window-maximize"
              ></i>
            )}
          </div>
        </div>
        {this.getHistoryCount() > 0 ? (
          <div
            style={{
              display: "flex",
              justifyContent:
                this.state.viewIdx === 1 ? "space-between" : "flex-end",
              alignItems: "center",
            }}
          >
            {this.state.viewIdx === 1 ? (
              <div
                className="searchBox"
                style={{
                  marginLeft: 12,
                  marginTop: 9,
                  width: this.props.isExpanded == "ct005" ? 365 : 185,
                }}
              >
                <input
                  type="text"
                  placeholder="search"
                  style={{
                    padding: "3px 8px",
                    borderRadius: 15,
                    width: "100%",
                    border: "1px solid #b1b1b1",
                    fontSize: 11,
                    color: "#4c4a4a",
                  }}
                  onChange={(e) => this.searchReport(e.target.value)}
                />
              </div>
            ) : null}
            <div className="topAction">
              <ul>
                <li
                  onClick={() =>
                    this.setState({ viewIdx: 0 }, () => {
                      this.renderLineChart(
                        this.props.isExpanded == "ct005" ? 500 : 400,
                        this.props.isExpanded == "ct005" ? 220 : 160
                      );
                    })
                  }
                  className={this.state.viewIdx === 0 ? "active" : ""}
                >
                  Chart
                </li>
                <li
                  onClick={() => this.setState({ viewIdx: 1 })}
                  className={this.state.viewIdx === 1 ? "active" : ""}
                >
                  Table
                </li>
              </ul>
            </div>
          </div>
        ) : null}

        {this.state.viewIdx === 0 ? (
          <div className="widgetbody">
            {this.getHistoryCount() === 0 ? (
              <img style={{ width: 200 }} src={EmptyState} />
            ) : (
              <div
                id="pieEV"
                ref="chargeHistoryGraph"
                style={{ position: "relative" }}
              ></div>
            )}
          </div>
        ) : (
          <div className="tableView">
            <Table
              ref={(ref) => {
                this.child = ref;
              }}
              data={this.props.data}
              heads={[
                {
                  heading: "Time",
                  key: "time",
                  format: "time",
                },
                {
                  heading: "Charging Events",
                  key: "count",
                },
              ]}
              metric="todaycharging"
              colorOn="soc"
              tableId="chargeEventTable"
            />
          </div>
        )}
      </div>
    );
  }
}

export default ChargeHistory;
